import { render } from "./OnboardingCaregiver.vue?vue&type=template&id=bdb40674&scoped=true"
import script from "./OnboardingCaregiver.vue?vue&type=script&lang=js"
export * from "./OnboardingCaregiver.vue?vue&type=script&lang=js"

import "./OnboardingCaregiver.vue?vue&type=style&index=0&id=bdb40674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb40674"]])

export default __exports__